





































import { Component, Vue } from 'vue-property-decorator';
import BitFlyer from '@/components/Orderbook/BitFlyerOrderbook.vue';
import BitMex from '@/components/Orderbook/BitMexOrderbook.vue';
import Bitfinex from '@/components/Orderbook/BitfinexOrderbook.vue';
import BitFlyerDiv from '@/components/MarketDataCard/BitFlyerDiv.vue';
import BitMexFundingRate from '@/components/MarketDataCard/BitMexFundingRate.vue';
import BitfinexLendingRate from '@/components/MarketDataCard/BitfinexLendingRate.vue';
import TimeAndSales from '@/components/TimeAndSales/TimeAndSales.vue';
import MarketVolume from '@/components/Volume/MarketVolume.vue';

@Component({
  name: 'Home',
  components: {
    BitFlyer,
    BitMex,
    Bitfinex,
    BitFlyerDiv,
    BitMexFundingRate,
    BitfinexLendingRate,
    TimeAndSales,
    MarketVolume,
  },
})
export default class Home extends Vue {
  public dark = true;
}
